import * as React from 'react';
import classNames from 'classnames';
const TransBtn = ({ className, customizeIcon, customizeIconProps, onMouseDown, onClick, children }) => {
    let icon;
    if (typeof customizeIcon === 'function') {
        icon = customizeIcon(customizeIconProps);
    }
    else {
        icon = customizeIcon;
    }
    return (React.createElement("span", { className: className, onMouseDown: event => {
            event.preventDefault();
            if (onMouseDown) {
                onMouseDown(event);
            }
        }, style: {
            userSelect: 'none',
            WebkitUserSelect: 'none',
        }, unselectable: "on", onClick: onClick, "aria-hidden": true }, icon !== undefined ? icon : React.createElement("span", { className: classNames(className.split(/\s+/).map(cls => `${cls}-icon`)) }, children)));
};
export default TransBtn;
